import moment, { Moment } from 'moment';

const disableTheDaysToCome =  (current:Moment)=> current > moment().endOf('day');

export { 
  disableTheDaysToCome
}
